import React, { Component } from 'react'

import classnames from 'classnames'

import parse from 'date-fns/parse'
import format from 'date-fns/format'

import DatePicker from 'material-ui-pickers/DatePicker'
import IconButton from '@material-ui/core/IconButton'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'

import './DateRange.css'

export const FORMATDATE = 'dd/MM/yyyy'
export const MINFORMATDATE = 'yyyy-MM-dd'

const emptyRange = (name, id) => ({
  id: -1,
  [name]: id,
  startDate: undefined,
  stopDate: undefined
})

const dateValidator = date =>
  date === undefined || date === 'mandatory' ? 'errorMandatory' : undefined

const rangeValidators = (startDate, stopDate) => {
  const startError = dateValidator(startDate)
  const stopError = dateValidator(stopDate)
  if (startError === undefined && stopError === undefined) {
    return {}
  } else {
    return { startDate: startError, stopDate: stopError }
  }
}

export default class PeriodDate extends Component {
  state = {
    newRange: emptyRange(this.props.nameId, this.props.elementId)
  }

  changeDate = (name, index) => newDate => {
    if (index === 'new') {
      this.setState(state => ({
        newRange: { ...state.newRange, [name]: format(newDate, FORMATDATE) }
      }))
    } else {
      this.props.changeDate(name, index, newDate)
    }
  }

  addRange = () => {
    const { newRange } = this.state
    const errors = rangeValidators(newRange.startDate, newRange.stopDate)

    this.setState(
      state => ({
        newRange: {
          ...state.newRange,
          startDate:
            errors.startDate !== undefined
              ? 'mandatory'
              : state.newRange.startDate,
          stopDate:
            errors.stopDate !== undefined
              ? 'mandatory'
              : state.newRange.stopDate
        }
      }),
      () => {
        const { addRange, nameId, elementId } = this.props
        if (Object.keys(errors).length === 0) {
          addRange(this.state.newRange)
          this.setState({ newRange: emptyRange(nameId, elementId) })
        }
      }
    )
  }

  deleteRange = index => () => {
    this.props.deleteRange(index)
  }

  renderDate(range, index) {
    const datepickerClasses = classnames('sp-period--datepicker', {
      'sp-period--datepicker__new': index === 'new'
    })

    return (
      <div key={`range-${index}`}>
        <DatePicker
          emptyLabel="Date de début"
          invalidLabel="Date de début"
          invalidDateMessage="Champ Obligatoire"
          className={datepickerClasses}
          label="Du"
          value={
            range.startDate !== undefined
              ? parse(range.startDate, FORMATDATE, new Date())
              : null
          }
          format={FORMATDATE}
          onChange={this.changeDate('startDate', index)}
        />
        <DatePicker
          minDate={
            range.startDate !== undefined
              ? format(
                  parse(range.startDate, FORMATDATE, new Date()),
                  MINFORMATDATE
                )
              : undefined
          }
          minDateMessage="Doit être après la date de début"
          emptyLabel="Date de fin"
          invalidLabel="Date de fin"
          invalidDateMessage="Champ Obligatoire"
          className={datepickerClasses}
          label="Au"
          value={
            range.stopDate !== undefined
              ? parse(range.stopDate, FORMATDATE, new Date())
              : null
          }
          format={FORMATDATE}
          onChange={this.changeDate('stopDate', index)}
        />
        {index === 'new' ? (
          range.startDate === undefined || range.stopDate === undefined ? (
            <div />
          ) : (
            <IconButton color="secondary" onClick={this.addRange}>
              <AddIcon />
            </IconButton>
          )
        ) : (
          <IconButton onClick={this.deleteRange(index)}>
            <RemoveIcon />
          </IconButton>
        )}
      </div>
    )
  }

  render() {
    const { ranges } = this.props
    const { newRange } = this.state
    return (
      <div>
        {ranges.map((range, index) => this.renderDate(range, index))}
        {this.renderDate(newRange, 'new')}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components-utils/DateRange.js